import React, { type ReactNode } from 'react'

function TwitterLogoIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="var(--color-icon-social)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.7227 4.75098C20.582 4.10645 21.3555 3.33301 21.957 2.43066C21.1836 2.77441 20.2812 3.03223 19.3789 3.11816C20.3242 2.55957 21.0117 1.7002 21.3555 0.625977C20.4961 1.1416 19.5078 1.52832 18.5195 1.74316C17.6602 0.84082 16.5 0.325195 15.2109 0.325195C12.7188 0.325195 10.6992 2.34473 10.6992 4.83691C10.6992 5.18066 10.7422 5.52441 10.8281 5.86816C7.08984 5.65332 3.73828 3.84863 1.50391 1.1416C1.11719 1.78613 0.902344 2.55957 0.902344 3.41895C0.902344 4.96582 1.67578 6.34082 2.92188 7.15723C2.19141 7.11426 1.46094 6.94238 0.859375 6.59863V6.6416C0.859375 8.83301 2.40625 10.6377 4.46875 11.0674C4.125 11.1533 3.69531 11.2393 3.30859 11.2393C3.00781 11.2393 2.75 11.1963 2.44922 11.1533C3.00781 12.958 4.68359 14.2471 6.66016 14.29C5.11328 15.4932 3.17969 16.2236 1.07422 16.2236C0.6875 16.2236 0.34375 16.1807 0 16.1377C1.97656 17.4268 4.33984 18.1572 6.91797 18.1572C15.2109 18.1572 19.7227 11.3252 19.7227 5.35254C19.7227 5.1377 19.7227 4.96582 19.7227 4.75098Z" />
    </svg>
  )
}

export default TwitterLogoIcon
